import React from 'react'
import PropTypes from 'prop-types'

import { StyledLink } from 'artkive/pages/Privacy/Link.style'
import { OLD_HELP_EMAIL } from 'artkive/utils/company'

export const EmailLink = () => <a href={`mailto:${OLD_HELP_EMAIL}`}>{OLD_HELP_EMAIL}</a>

const Link = ({ href, children }) => (
  <StyledLink href={href} target='_blank' rel='noreferrer'>
    {children || href}
  </StyledLink>
)

Link.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default Link
